import type { JSX } from "react";

import { ChangeValue } from "@similarweb/ui-components";

import { abbrNumberSupportNegativeFilter, percentageSignFilter } from "app/filters/ngFilters";

import type { DataItem } from "./types";

export const getLegendData = (data: DataItem[], isPercentageMode: boolean): JSX.Element => {
    const numberFilter = isPercentageMode ? percentageSignFilter : abbrNumberSupportNegativeFilter;

    const { currentPeriodSum, comparePeriodSum } = data.reduce(
        (acc, { values }) => {
            const currentValue = values[0]?.Value ?? 0;
            const compareValue = values[1]?.Value ?? 0;
            acc.currentPeriodSum += currentValue;
            acc.comparePeriodSum += compareValue;
            return acc;
        },
        { currentPeriodSum: 0, comparePeriodSum: 0 },
    );

    const sum = isPercentageMode
        ? comparePeriodSum === 0
            ? 0
            : (currentPeriodSum - comparePeriodSum) / comparePeriodSum
        : currentPeriodSum - comparePeriodSum;

    return (
        <ChangeValue
            // @ts-expect-error FIXME: functions "percentageSignFilter" and "abbrNumberSupportNegativeFilter" have different type of arguments
            value={numberFilter()(sum, 2)}
            isDecrease={sum < 0}
        />
    );
};
